import { inject, injectable, interfaces, multiInject, named, optional } from 'inversify';
import { ServiceIdentifierOrFunc } from 'inversify/lib/annotation/lazy_service_identifier';

export const Injectable = (): ReturnType<typeof injectable> => injectable();

export const Inject = <T = unknown> (
  serviceIdentifier: ServiceIdentifierOrFunc<T>,
): ReturnType<typeof inject<T>> => inject(serviceIdentifier);

export const Optional = (): ReturnType<typeof optional> => optional();

export const Named = (name: string | number | symbol): ReturnType<typeof named> => named(name);

export const MultiInject =
  <T = unknown> (serviceIdentifier: interfaces.ServiceIdentifier<T>): ReturnType<typeof multiInject<T>> =>
    multiInject<T>(serviceIdentifier);
